export default __webpack_public_path__ + "static/slack-399a11ae4b3e3a4a0753e52d645ee6af.svg";